import request from '@/utilities/request'

// 登录
export function login(data) {
    return request({
      url: 'user/public/loginTea',
      method: 'post',
      data
    })
}

// 退出登录
export function logout() {
    return request({
      url: 'user/public/logout',
      method: 'get'
    })
}

// 注册
export function registerAccount(data) {
    return request({
        url:"user/public/register",
        method:"post",
        data
    })
}

// 发送短信验证码
export function codeSend(mobile){
    return request({
        url:"user/verification_code/send",
        method:"post",
        data:{username:mobile}
    })
}